(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  /* Category tabs */
  (function() {
    var buttons = document.querySelectorAll('.faq-cat-btn');
    var sections = document.querySelectorAll('.faq-cat-section');

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        buttons.forEach(function(b) { b.classList.remove('active'); });
        sections.forEach(function(s) { s.classList.remove('active'); });
        btn.classList.add('active');
        var target = document.getElementById('faq-cat-' + btn.dataset.cat);
        if (target) target.classList.add('active');
      });
    });
  })();

  /* FAQ accordion */
  (function() {
    document.querySelectorAll('.faq-q').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.faq-item');
        var isOpen = item.classList.contains('open');
        var section = item.closest('.faq-cat-section') || item.closest('.faq-page__wrap');

        section.querySelectorAll('.faq-item').forEach(function(i) {
          i.classList.remove('open');
          i.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
          i.querySelector('.faq-a').style.maxHeight = '0';
        });

        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
          item.querySelector('.faq-a').style.maxHeight = item.querySelector('.faq-a').scrollHeight + 'px';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-home"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('on');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.reveal').forEach(function(el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-legal"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.legal-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.legal-btn').forEach(function(b) { b.classList.remove('active'); });
        document.querySelectorAll('.legal-section').forEach(function(s) { s.classList.remove('active'); });
        btn.classList.add('active');
        var target = document.getElementById('legalpane-' + btn.dataset.legalTab);
        if (target) target.classList.add('active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-accessory"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    /* ── Direct add to cart ── */
    function addToCart(btn) {
      var variantId = document.querySelector('input[name="id"]');
      if (!variantId) return;
      btn.textContent = '...';
      btn.disabled = true;
      if (typeof YOURAYOUCart !== 'undefined') {
        YOURAYOUCart.addToCart(parseInt(variantId.value), 1)
          .then(function() { if (typeof YOURAYOUCart.updateBadge === 'function') YOURAYOUCart.updateBadge(); })
          .then(function() { window.location.href = '/cart'; });
      } else {
        var form = document.getElementById('product-form-accessory');
        if (form) form.submit();
      }
    }

    var ctaBtn = document.getElementById('cta-desktop');
    var ctaStickyBtn = document.getElementById('cta-sticky');
    if (ctaBtn) ctaBtn.addEventListener('click', function() { addToCart(ctaBtn); });
    if (ctaStickyBtn) ctaStickyBtn.addEventListener('click', function() { addToCart(ctaStickyBtn); });

    /* ── Info image carousel ── */
    document.querySelectorAll('.info-img-arrow').forEach(function(arrow) {
      arrow.addEventListener('click', function() {
        var area = arrow.closest('.info-img');
        var slides = area.querySelectorAll('.info-slide');
        var dots = area.querySelectorAll('.info-img-dot');
        if (slides.length < 2) return;
        var current = Array.from(slides).findIndex(function(s) { return s.classList.contains('active'); });
        var dir = parseInt(arrow.dataset.dir);
        var next = (current + dir + slides.length) % slides.length;
        slides[current].classList.remove('active'); slides[current].style.display = 'none';
        slides[next].classList.add('active'); slides[next].style.display = '';
        dots.forEach(function(d, i) { d.classList.toggle('on', i === next); });
      });
    });

    /* ── Scroll reveal ── */
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('on'); obs.unobserve(e.target); } });
    }, {threshold:0.08});
    document.querySelectorAll('.reveal').forEach(function(el) { obs.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-cart"] && !Shopify.designMode) return;
  try {
    
  /* AJAX cart with Section Rendering API */
  (function() {
    var section = document.getElementById('cart-section');
    if (!section) return;

    /* Event delegation — survives innerHTML replacement */
    section.addEventListener('click', function(e) {
      var qtyBtn = e.target.closest('.cart-qty-btn');
      var removeBtn = e.target.closest('.cart-item-remove');

      if (qtyBtn) {
        e.preventDefault();
        var key = qtyBtn.dataset.key;
        var currentQty = parseInt(qtyBtn.dataset.qty);
        var newQty = qtyBtn.dataset.action === 'plus' ? currentQty + 1 : currentQty - 1;
        if (newQty < 1) newQty = 0;
        if (typeof YOURAYOUCart !== 'undefined') {
          YOURAYOUCart.updateCart(key, newQty)
            .then(YOURAYOUCart.renderSection)
            .then(YOURAYOUCart.updateBadge);
        }
      }

      if (removeBtn) {
        e.preventDefault();
        var key = removeBtn.dataset.key;
        if (typeof YOURAYOUCart !== 'undefined') {
          YOURAYOUCart.removeFromCart(key)
            .then(YOURAYOUCart.renderSection)
            .then(YOURAYOUCart.updateBadge);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var rootEl = document.querySelector('.coll-section-root[data-section-id]');
    var sid = rootEl ? rootEl.getAttribute('data-section-id') : '';

    function $(id) { return document.getElementById(id + '-' + sid) || document.getElementById(id); }
    function $$(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

    /* ── STATE ── */
    var state = { color: null, mood: null, priceMin: 0, priceMax: 100, sort: 'best' };
    var pending = Object.assign({}, state);

    var gridEl = $('collection-grid');
    var cards = gridEl ? Array.from(gridEl.querySelectorAll('.coll-product-card')) : [];
    var noResults = $('no-results');

    /* ── APPLY ── */
    function applyFilters() {
      state = Object.assign({}, pending);
      var visible = 0;
      cards.forEach(function(card) {
        var colorOk = !state.color || card.dataset.color === state.color;
        var moodOk  = !state.mood  || card.dataset.mood  === state.mood;
        var price   = parseFloat(card.dataset.price) || 0;
        var priceOk = price >= state.priceMin && price <= state.priceMax;
        var show = colorOk && moodOk && priceOk;
        card.classList.toggle('hidden', !show);
        if (show) visible++;
      });
      if (noResults) noResults.classList.toggle('visible', visible === 0);
      sortCards();
      closePanels();
    }

    function sortCards() {
      if (!gridEl) return;
      var visibleCards = cards.filter(function(c){ return !c.classList.contains('hidden'); });
      visibleCards.sort(function(a, b) {
        if (state.sort === 'az') return a.querySelector('.coll-card-name').textContent.localeCompare(b.querySelector('.coll-card-name').textContent);
        if (state.sort === 'price-asc') return (parseFloat(a.dataset.price)||0) - (parseFloat(b.dataset.price)||0);
        if (state.sort === 'price-desc') return (parseFloat(b.dataset.price)||0) - (parseFloat(a.dataset.price)||0);
        return 0;
      });
      visibleCards.forEach(function(c){ gridEl.appendChild(c); });
    }

    function closePanels() {
      var panel = $('filter-panel');
      var backdrop = $('filter-backdrop');
      var bigClose = $('filter-big-close');
      var sheet = $('filter-sheet');
      var sheetBackdrop = $('filter-sheet-backdrop');
      if (panel) panel.classList.remove('open');
      if (backdrop) backdrop.classList.remove('open');
      if (bigClose) bigClose.classList.remove('open');
      if (sheet) sheet.classList.remove('open');
      if (sheetBackdrop) sheetBackdrop.classList.remove('open');
      document.body.style.overflow = '';
    }

    /* ── FILTER SECTION ACCORDION ── */
    $$('.coll-filter-section-head').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var section = btn.closest('.coll-filter-section');
        section.classList.toggle('open');
        var body = section.querySelector('.coll-filter-section-body');
        if (section.classList.contains('open')) {
          body.style.maxHeight = body.scrollHeight + 'px';
        } else {
          body.style.maxHeight = '0';
        }
      });
    });
    /* Open initial sections */
    $$('.coll-filter-section.open .coll-filter-section-body').forEach(function(b){
      b.style.maxHeight = b.scrollHeight + 'px';
    });

    /* ── COLOR DOTS ── */
    $$('.coll-filter-color-dot').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var val = btn.dataset.val;
        if (pending.color === val) {
          pending.color = null;
          btn.classList.remove('active');
        } else {
          $$('.coll-filter-color-dot').forEach(function(b){ b.classList.remove('active'); });
          pending.color = val;
          btn.classList.add('active');
        }
      });
    });

    /* ── MOOD CHECKBOXES ── */
    $$('.coll-filter-check-item').forEach(function(item) {
      item.addEventListener('click', function() {
        var val = item.dataset.val;
        var filter = item.dataset.filter;
        if (pending[filter] === val) {
          pending[filter] = null;
          item.classList.remove('active');
        } else {
          $$('.coll-filter-check-item[data-filter="'+filter+'"]').forEach(function(i){ i.classList.remove('active'); });
          pending[filter] = val;
          item.classList.add('active');
        }
      });
    });

    /* ── PRICE SLIDER ── */
    (function() {
      var range = $('price-range');
      var thumbMin = $('thumb-min');
      var thumbMax = $('thumb-max');
      var fill = $('price-fill');
      var inputMin = $('price-min-input');
      var inputMax = $('price-max-input');
      if (!range || !thumbMin || !thumbMax) return;
      var MIN = 0, MAX = parseInt(inputMax ? inputMax.getAttribute('max') : 100) || 100;
      var dragging = null;

      function updateSlider() {
        var pMin = (pending.priceMin - MIN) / (MAX - MIN) * 100;
        var pMax = (pending.priceMax - MIN) / (MAX - MIN) * 100;
        thumbMin.style.left = pMin + '%';
        thumbMax.style.left = pMax + '%';
        if (fill) { fill.style.left = pMin + '%'; fill.style.width = (pMax - pMin) + '%'; }
        if (inputMin) inputMin.value = pending.priceMin;
        if (inputMax) inputMax.value = pending.priceMax;
      }

      function getPercent(e) {
        var rect = range.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        return Math.max(0, Math.min(100, x / rect.width * 100));
      }

      [thumbMin, thumbMax].forEach(function(thumb) {
        thumb.addEventListener('mousedown', function(e){ dragging = thumb; e.preventDefault(); });
        thumb.addEventListener('touchstart', function(e){ dragging = thumb; }, {passive:true});
      });
      document.addEventListener('mousemove', function(e) {
        if (!dragging) return;
        var pct = getPercent(e);
        var val = Math.round(MIN + pct / 100 * (MAX - MIN));
        if (dragging === thumbMin) { pending.priceMin = Math.min(val, pending.priceMax - 1); }
        else { pending.priceMax = Math.max(val, pending.priceMin + 1); }
        updateSlider();
      });
      document.addEventListener('touchmove', function(e) {
        if (!dragging) return;
        var pct = getPercent(e);
        var val = Math.round(MIN + pct / 100 * (MAX - MIN));
        if (dragging === thumbMin) { pending.priceMin = Math.min(val, pending.priceMax - 1); }
        else { pending.priceMax = Math.max(val, pending.priceMin + 1); }
        updateSlider();
      }, {passive:true});
      document.addEventListener('mouseup', function(){ dragging = null; });
      document.addEventListener('touchend', function(){ dragging = null; });

      if (inputMin) inputMin.addEventListener('input', function() {
        pending.priceMin = Math.min(parseInt(this.value)||0, pending.priceMax - 1);
        updateSlider();
      });
      if (inputMax) inputMax.addEventListener('input', function() {
        pending.priceMax = Math.max(parseInt(this.value)||MAX, pending.priceMin + 1);
        updateSlider();
      });

      pending.priceMin = MIN; pending.priceMax = MAX;
      updateSlider();
    })();

    /* ── SORT (panel sort-radio-item) ── */
    function bindSortItems(container) {
      if (!container) return;
      container.querySelectorAll('.coll-sort-radio-item').forEach(function(item) {
        item.addEventListener('click', function() {
          container.querySelectorAll('.coll-sort-radio-item').forEach(function(i){ i.classList.remove('active'); });
          item.classList.add('active');
          pending.sort = item.dataset.sort;
        });
      });
    }
    bindSortItems($('filter-panel'));

    /* ── PANEL OPEN / CLOSE ── */
    var filterBigClose = $('filter-big-close');
    var showBtn = $('filter-show-btn');
    if (showBtn) {
      showBtn.addEventListener('click', function() {
        var panel = $('filter-panel');
        var backdrop = $('filter-backdrop');
        if (panel) panel.classList.add('open');
        if (backdrop) backdrop.classList.add('open');
        document.body.style.overflow = 'hidden';
        if (filterBigClose) filterBigClose.classList.add('open');
      });
    }

    /* Big close cursor tracking */
    document.addEventListener('mousemove', function(e) {
      if (!filterBigClose || !filterBigClose.classList.contains('open')) return;
      filterBigClose.style.left = e.clientX + 'px';
      filterBigClose.style.top = e.clientY + 'px';
      var panel = $('filter-panel');
      if (panel) {
        var rect = panel.getBoundingClientRect();
        var inside = e.clientX >= rect.left && e.clientX <= rect.right
                  && e.clientY >= rect.top  && e.clientY <= rect.bottom;
        filterBigClose.style.opacity = inside ? '0' : '1';
      }
    });

    var panelClose = $('filter-panel-close');
    var backdrop = $('filter-backdrop');
    if (panelClose) panelClose.addEventListener('click', closePanels);
    if (backdrop) backdrop.addEventListener('click', closePanels);
    if (filterBigClose) filterBigClose.addEventListener('click', closePanels);

    /* ── MOBILE SHEET ── */
    var mobileBtn = $('filter-mobile-btn');
    if (mobileBtn) {
      mobileBtn.addEventListener('click', function() {
        var sheetBody = $('filter-sheet-body');
        var panelBody = document.getElementById('filter-panel-body-' + sid);
        if (sheetBody && panelBody) {
          sheetBody.innerHTML = panelBody.innerHTML;
          /* Re-bind events */
          sheetBody.querySelectorAll('.coll-filter-section-head').forEach(function(btn) {
            btn.addEventListener('click', function() {
              var section = btn.closest('.coll-filter-section');
              section.classList.toggle('open');
              var body = section.querySelector('.coll-filter-section-body');
              body.style.maxHeight = section.classList.contains('open') ? body.scrollHeight + 'px' : '0';
            });
            var sec = btn.closest('.coll-filter-section');
            if (sec.classList.contains('open')) {
              var b = sec.querySelector('.coll-filter-section-body');
              b.style.maxHeight = b.scrollHeight + 'px';
            }
          });
          sheetBody.querySelectorAll('.coll-filter-color-dot').forEach(function(dot) {
            if (pending.color === dot.dataset.val) dot.classList.add('active');
            dot.addEventListener('click', function() {
              var val = dot.dataset.val;
              sheetBody.querySelectorAll('.coll-filter-color-dot').forEach(function(d){ d.classList.remove('active'); });
              if (pending.color === val) { pending.color = null; }
              else { pending.color = val; dot.classList.add('active'); }
              $$('.coll-filter-color-dot[data-val="'+val+'"]').forEach(function(d){
                d.classList.toggle('active', pending.color === val);
              });
            });
          });
          sheetBody.querySelectorAll('.coll-filter-check-item').forEach(function(item) {
            if (pending[item.dataset.filter] === item.dataset.val) item.classList.add('active');
            item.addEventListener('click', function() {
              var val = item.dataset.val; var filter = item.dataset.filter;
              sheetBody.querySelectorAll('.coll-filter-check-item[data-filter="'+filter+'"]').forEach(function(i){ i.classList.remove('active'); });
              if (pending[filter] === val) { pending[filter] = null; }
              else { pending[filter] = val; item.classList.add('active'); }
            });
          });
          bindSortItems(sheetBody);
        }
        var sheet = $('filter-sheet');
        var sheetBackdrop = $('filter-sheet-backdrop');
        if (sheet) sheet.classList.add('open');
        if (sheetBackdrop) sheetBackdrop.classList.add('open');
        document.body.style.overflow = 'hidden';
        var applyBtn = $('filter-sheet-apply-btn');
        if (applyBtn) {
          applyBtn.style.pointerEvents = 'none';
          setTimeout(function() { applyBtn.style.pointerEvents = ''; }, 400);
        }
      });
    }

    var sheetClose = $('filter-sheet-close');
    var sheetBackdropEl = $('filter-sheet-backdrop');
    if (sheetClose) sheetClose.addEventListener('click', closePanels);
    if (sheetBackdropEl) sheetBackdropEl.addEventListener('click', closePanels);

    /* ── APPLY BUTTONS ── */
    var applyBtn = $('filter-apply-btn');
    var sheetApplyBtn = $('filter-sheet-apply-btn');
    if (applyBtn) applyBtn.addEventListener('click', applyFilters);
    if (sheetApplyBtn) {
      sheetApplyBtn.addEventListener('click', applyFilters);
      sheetApplyBtn.addEventListener('mouseenter', function() { sheetApplyBtn.classList.add('pressed'); });
      sheetApplyBtn.addEventListener('mouseleave', function() { sheetApplyBtn.classList.remove('pressed'); });
      sheetApplyBtn.addEventListener('touchstart', function() { sheetApplyBtn.classList.add('pressed'); }, { passive: true });
      sheetApplyBtn.addEventListener('touchend', function() {
        setTimeout(function() { sheetApplyBtn.classList.remove('pressed'); }, 200);
      }, { passive: true });
      sheetApplyBtn.addEventListener('touchcancel', function() { sheetApplyBtn.classList.remove('pressed'); }, { passive: true });
    }

    /* ── FILTER BTN — hide before footer ── */
    var filterMobileBtn = $('filter-mobile-btn');
    function checkFilterBtnVisibility() {
      if (!filterMobileBtn) return;
      var footer = document.querySelector('footer');
      if (footer) {
        var rect = footer.getBoundingClientRect();
        filterMobileBtn.style.opacity = rect.top < window.innerHeight ? '0' : '';
        filterMobileBtn.style.pointerEvents = rect.top < window.innerHeight ? 'none' : '';
      }
    }
    document.addEventListener('scroll', checkFilterBtnVisibility, { passive: true });
    checkFilterBtnVisibility();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-product-bundle"] && !Shopify.designMode) return;
  try {
    
  /* Color panel logic */
  (function() {
    var colorsNeeded = parseInt('{{ section.settings.colors_to_select }}') || 3;
    var variantId = '{{ product.selected_or_first_available_variant.id }}';
    var selected = [];
    var panel = document.getElementById('color-panel');
    var overlay = document.getElementById('panel-overlay');
    var openBtn = document.getElementById('open-color-panel');
    var closeBtn = document.getElementById('panel-close');
    var confirmBtn = document.getElementById('panel-confirm');
    var statusEl = document.getElementById('panel-status');
    var nameEl = document.getElementById('color-name');
    var addBtn = document.getElementById('bundle-add-to-cart');

    function openPanel() { panel.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow='hidden'; }
    function closePanel() { panel.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow=''; }

    if (openBtn) openBtn.addEventListener('click', openPanel);
    if (closeBtn) closeBtn.addEventListener('click', closePanel);
    if (overlay) overlay.addEventListener('click', closePanel);

    document.querySelectorAll('.panel-swatch').forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        var name = swatch.dataset.name;
        if (swatch.classList.contains('selected')) {
          swatch.classList.remove('selected');
          selected = selected.filter(function(s) { return s !== name; });
        } else if (selected.length < colorsNeeded) {
          swatch.classList.add('selected');
          selected.push(name);
        }
        statusEl.textContent = selected.length + ' / ' + colorsNeeded;
        confirmBtn.disabled = selected.length !== colorsNeeded;
      });
    });

    if (confirmBtn) confirmBtn.addEventListener('click', function() {
      if (selected.length !== colorsNeeded) return;
      nameEl.textContent = '— ' + selected.join(', ');
      addBtn.disabled = false;
      closePanel();
    });

    if (addBtn) addBtn.addEventListener('click', function() {
      if (selected.length !== colorsNeeded) return;
      var properties = {};
      selected.forEach(function(color, i) { properties['Teinte ' + (i + 1)] = color; });
      if (typeof YOURAYOUCart !== 'undefined') {
        YOURAYOUCart.addToCart(parseInt(variantId), 1, properties)
          .then(YOURAYOUCart.updateBadge)
          .then(function() { window.location.href = '/cart'; });
      }
    });
  })();

  /* Image carousel */
  (function() {
    var thumbs = document.querySelectorAll('.thumb[data-index]');
    var mainImg = document.getElementById('main-img');
    var currentSlide = 0;
    var total = thumbs.length;
    if (!total || !mainImg) return;

    function goTo(idx) {
      currentSlide = ((idx % total) + total) % total;
      thumbs.forEach(function(t, i) { t.classList.toggle('active', i === currentSlide); });
      mainImg.src = thumbs[currentSlide].dataset.src;
    }

    var prevBtn = document.getElementById('btn-prev');
    var nextBtn = document.getElementById('btn-next');
    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(currentSlide - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(currentSlide + 1); });
    thumbs.forEach(function(t, i) { t.addEventListener('click', function() { goTo(i); }); });
  })();

  /* FAQ accordion */
  (function() {
    document.querySelectorAll('.faq-q').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.faq-item');
        var isOpen = item.classList.contains('open');
        item.closest('.faq-section').querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-product"] && !Shopify.designMode) return;
  try {
    
  /* ── Related Bar — hide near discover/footer ── */
  function checkRelatedBarVisibility() {
    var bar = document.querySelector('.related-bar');
    if (!bar) return;
    var target = document.querySelector('.ya-disc-section') || document.querySelector('footer');
    if (target) {
      var rect = target.getBoundingClientRect();
      bar.style.display = rect.top < window.innerHeight ? 'none' : '';
    }
  }
  window.addEventListener('scroll', checkRelatedBarVisibility, { passive: true });
  window.addEventListener('resize', checkRelatedBarVisibility);
  checkRelatedBarVisibility();

  /* ── Related bar scroll ── */
  var itemsEl = document.getElementById('related-items');
  var scrollBtn = document.getElementById('related-scroll-btn');
  if (itemsEl && scrollBtn) {
    scrollBtn.addEventListener('click', function() {
      if (window.innerWidth <= 768) return;
      var max = itemsEl.scrollWidth - itemsEl.clientWidth;
      if (itemsEl.scrollLeft >= max - 10) { itemsEl.scrollLeft = 0; scrollBtn.textContent = '\u2192'; }
      else { itemsEl.scrollLeft += 360; }
    });
    itemsEl.addEventListener('scroll', function() {
      var max = itemsEl.scrollWidth - itemsEl.clientWidth;
      scrollBtn.textContent = itemsEl.scrollLeft >= max - 10 ? '\u2190' : '\u2192';
    });
  }

  /* Related item click → navigate */
  document.querySelectorAll('.related-item').forEach(function(item) {
    item.addEventListener('click', function(e) {
      if (e.target.classList.contains('related-item-add')) return;
      var href = item.dataset.href;
      if (href) location.href = href;
    });
  });

  /* Related item add to cart */
  document.querySelectorAll('.related-item-add').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var variantId = btn.dataset.variantId;
      if (typeof YOURAYOUCart !== 'undefined' && variantId) {
        btn.textContent = '\u2713'; btn.style.background = 'var(--ya-black)'; btn.style.color = 'var(--ya-white)'; btn.style.borderColor = 'var(--ya-black)';
        YOURAYOUCart.addToCart(parseInt(variantId), 1)
          .then(function(response) {
            if (window.YOURAYOU && typeof YOURAYOU.renderCartDrawer === 'function') YOURAYOU.renderCartDrawer(response);
            if (typeof YOURAYOUCart.updateBadge === 'function') YOURAYOUCart.updateBadge(response);
          })
          .finally(function() {
            setTimeout(function() { btn.textContent = '+'; btn.style.background = ''; btn.style.color = ''; btn.style.borderColor = ''; }, 1500);
          });
      } else {
        btn.textContent = '\u2713'; btn.style.background = 'var(--ya-black)'; btn.style.color = 'var(--ya-white)'; btn.style.borderColor = 'var(--ya-black)';
        setTimeout(function() { btn.textContent = '+'; btn.style.background = ''; btn.style.color = ''; btn.style.borderColor = ''; }, 1500);
      }
    });
  });

  /* Related buy button → add current product */
  var relatedBuyBtn = document.getElementById('related-buy-btn');
  if (relatedBuyBtn) {
    relatedBuyBtn.addEventListener('click', function() {
      var form = document.querySelector('[id^="product-form-"]');
      if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  /* ── AJAX Add to Cart ── */
  (function() {
    var form = document.querySelector('[id^="product-form-"]');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var id = form.querySelector('input[name="id"]').value;
      var qty = parseInt(form.querySelector('input[name="quantity"]').value) || 1;
      if (typeof YOURAYOUCart !== 'undefined') {
        YOURAYOUCart.addToCart(parseInt(id), qty)
          .then(function(response) {
            if (window.YOURAYOU && typeof YOURAYOU.openCartDrawer === 'function') {
              if (typeof YOURAYOU.renderCartDrawer === 'function') YOURAYOU.renderCartDrawer(response);
              if (typeof YOURAYOUCart.updateBadge === 'function') YOURAYOUCart.updateBadge(response);
              YOURAYOU.openCartDrawer();
            } else {
              if (typeof YOURAYOUCart.updateBadge === 'function') YOURAYOUCart.updateBadge();
              window.location.href = '/cart';
            }
          });
      } else {
        form.submit();
      }
    });
  })();

  /* ── i18n for review strings ── */
  var sec = document.querySelector('.ya-hero[data-i18n-anonymous], .hero[data-i18n-anonymous]');
  window.__yaI18n = {
    anonymous: sec ? sec.getAttribute('data-i18n-anonymous') : 'Anonymous',
    review: sec ? sec.getAttribute('data-i18n-review') : 'Review',
    verified: sec ? sec.getAttribute('data-i18n-verified') : 'Verified purchase',
    justNow: sec ? sec.getAttribute('data-i18n-just-now') : 'just now'
  };

  /* ── Scroll reveal ── */
  var revObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('on'); revObs.unobserve(e.target); }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(function(el) { revObs.observe(el); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-refill"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    /* Sélection de pack (set + slots + tiroir) gérée par custom-pack-select.js (auto-init). */

    /* ── Goto reviews ── */
    var gotoReviews = document.getElementById('goto-reviews');
    if (gotoReviews) gotoReviews.addEventListener('click', function() {
      document.getElementById('reviews').scrollIntoView({behavior:'smooth'});
    });

    /* ── Mobile thumb strip ── */
    document.querySelectorAll('.m-thumb').forEach(function(mt) {
      mt.addEventListener('click', function() {
        var idx = parseInt(mt.dataset.index);
        document.querySelectorAll('.m-thumb').forEach(function(m, j) { m.classList.toggle('active', j === idx); });
        /* sync shared gallery */
        var thumbs = document.querySelectorAll('.ya-gallery__thumb[data-index]');
        if (thumbs[idx]) thumbs[idx].click();
      });
    });
    var mStripPrev = document.getElementById('m-strip-prev');
    var mStripNext = document.getElementById('m-strip-next');
    if (mStripPrev) mStripPrev.addEventListener('click', function() {
      var active = document.querySelector('.m-thumb.active');
      var idx = active ? parseInt(active.dataset.index) : 0;
      var prev = (idx - 1 + document.querySelectorAll('.m-thumb').length) % document.querySelectorAll('.m-thumb').length;
      document.querySelectorAll('.m-thumb')[prev].click();
    });
    if (mStripNext) mStripNext.addEventListener('click', function() {
      var active = document.querySelector('.m-thumb.active');
      var idx = active ? parseInt(active.dataset.index) : 0;
      var next = (idx + 1) % document.querySelectorAll('.m-thumb').length;
      document.querySelectorAll('.m-thumb')[next].click();
    });

    /* ── Sticky CTA mobile ──
       overflow-x:clip sur body crée un containing block pour position:fixed dans Chrome,
       ce qui rend bottom:0 relatif au bas du document et non du viewport.
       Solution : déplacer l'élément en enfant direct de <body> pour contourner ce bug. */
    var stickWrap = document.getElementById('sticky-cta-wrap');
    if (stickWrap && window.innerWidth <= 768) {
      document.body.appendChild(stickWrap);
      function checkRefillSticky() {
        var disc = document.querySelector('.ya-disc-section');
        var footer = document.querySelector('footer');
        var hideEl = disc || footer;
        if (hideEl) {
          var r = hideEl.getBoundingClientRect();
          if (r.top < window.innerHeight) { stickWrap.style.display = 'none'; return; }
        }
        stickWrap.style.display = 'block';
      }
      window.addEventListener('scroll', checkRefillSticky, { passive: true });
      checkRefillSticky();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-starter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    /* ── Inclus grid (accordéon) — synchronisé au set actif via pack:setchange ── */
    var icons = {
      layer:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M6.2 16V10.5a1.3 1.3 0 0 1 2.6 0V16"/><path d="M10.7 16V10.5a1.3 1.3 0 0 1 2.6 0V16"/><path d="M15.2 16V10.5a1.3 1.3 0 0 1 2.6 0V16"/></svg>',
      lamp:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="6" width="16" height="6.5" rx="2.2"/><line x1="10.8" y1="9.3" x2="13.2" y2="9.3"/><line x1="8" y1="12.5" x2="5.5" y2="18.5"/><line x1="16" y1="12.5" x2="18.5" y2="18.5"/></svg>',
      file:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3.2" y="8.5" width="9.5" height="9.5" rx="1.2"/><line x1="3.2" y1="11" x2="12.7" y2="11"/><rect x="15.2" y="4.2" width="2.3" height="15" rx="1.15" transform="rotate(22 16.3 11.7)"/></svg>',
      topcoat:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="10" width="8" height="10" rx="1.3"/><rect x="10" y="7.6" width="4" height="2.6"/><rect x="9.3" y="3" width="5.4" height="4.6" rx="1"/></svg>',
      remover:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.6C12 3.6 17.5 10.5 17.5 14.5a5.5 5.5 0 0 1-11 0C6.5 10.5 12 3.6 12 3.6Z"/><path d="M10 15a2.4 2.4 0 0 0 1.4 2.2"/></svg>',
      buffer:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12,3 14,9 21,9 15.5,13.5 17.5,20 12,16 6.5,20 8.5,13.5 3,9 10,9"/></svg>',
      pstick:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 13.7 6.5 13.1 19a1.1 1.1 0 0 1-2.2 0L10.3 6.5Z"/><line x1="10.7" y1="9.5" x2="13.3" y2="9.5"/></svg>',
      tin:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="6" width="19" height="12" rx="2"/><rect x="4.6" y="8" width="14.8" height="8" rx="1.2"/></svg>'
    };
    var kitDataEl = document.getElementById('kit-data');
    var kitDataParsed = kitDataEl ? JSON.parse(kitDataEl.textContent) : {};
    var kitItems = {}, kitCols = {};
    Object.keys(kitDataParsed).forEach(function(key) {
      kitItems[key] = kitDataParsed[key].items || [];
      kitCols[key] = kitDataParsed[key].cols || 3;
    });
    function renderIncGrid(kitKey) {
      var items = kitItems[kitKey]; var cols = kitCols[kitKey];
      var grid = document.getElementById('inc-grid');
      if (!grid || !items) return;
      grid.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)';
      grid.innerHTML = items.map(function(item, i) {
        var isLastCol = (i + 1) % cols === 0;
        var isLastRow = i >= items.length - cols;
        return '<div class="inc-cell" style="' + (isLastCol ? 'border-right:none;' : '') + (isLastRow ? 'border-bottom:none;' : '') + '">'
          + '<div class="inc-photo">' + (icons[item.icon] || '') + '</div>'
          + '<div class="inc-cell-name">' + item.n + '</div>'
          + (item.red ? '<div class="inc-cell-red">' + item.v + '</div>' : '<div class="inc-cell-val">' + item.v + '</div>')
          + '</div>';
      }).join('');
    }
    var firstKit = Object.keys(kitDataParsed)[0];
    if (firstKit) renderIncGrid(firstKit);
    document.addEventListener('pack:setchange', function(e) { if (e.detail && e.detail.key) renderIncGrid(e.detail.key); });

    /* ── Accordions ── */
    document.querySelectorAll('.acc-trigger').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.acc-item');
        var open = item.classList.contains('open');
        document.querySelectorAll('.acc-item').forEach(function(i) { i.classList.remove('open'); });
        if (!open) item.classList.add('open');
      });
    });

    /* ── Tabs ── */
    document.querySelectorAll('.tab-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('active'); });
        document.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.remove('active'); });
        btn.classList.add('active');
        var panel = document.getElementById('tab-' + btn.dataset.tab);
        if (panel) panel.classList.add('active');
      });
    });

    /* ── Tab image carousel ── */
    document.querySelectorAll('.tab-img-arrow').forEach(function(arrow) {
      arrow.addEventListener('click', function() {
        var area = arrow.closest('.tab-img-area');
        var slides = area.querySelectorAll('.tab-slide');
        var dots = area.querySelectorAll('.tab-img-dot');
        if (slides.length < 2) return;
        var current = Array.from(slides).findIndex(function(s) { return s.classList.contains('active'); });
        var dir = parseInt(arrow.dataset.dir);
        var next = (current + dir + slides.length) % slides.length;
        slides[current].classList.remove('active'); slides[current].style.display = 'none';
        slides[next].classList.add('active'); slides[next].style.display = '';
        dots.forEach(function(d, i) { d.classList.toggle('on', i === next); });
      });
    });

    /* ── Goto reviews ── */
    var gotoReviews = document.getElementById('goto-reviews');
    if (gotoReviews) gotoReviews.addEventListener('click', function() {
      document.getElementById('reviews').scrollIntoView({behavior:'smooth'});
    });
  });

  } catch(e) { console.error(e); }
})();
})();
